import { configureStore } from "@reduxjs/toolkit";
import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import createRootReducer from "../reducers";

import type FixMeLater from "../../shared/types/fixMeLater.type";

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);

const store = configureStore({
  reducer: createRootReducer(history), // root reducer with router state
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(routeMiddleware as FixMeLater),
  devTools: true, // Enable Redux DevTools in development mode
  preloadedState: undefined as FixMeLater | undefined
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
